import { render, staticRenderFns } from "./AdminRoutePlan.vue?vue&type=template&id=568a3a92&scoped=true"
import script from "./AdminRoutePlan.vue?vue&type=script&lang=js"
export * from "./AdminRoutePlan.vue?vue&type=script&lang=js"
import style0 from "./AdminRoutePlan.vue?vue&type=style&index=0&id=568a3a92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568a3a92",
  null
  
)

export default component.exports